/* Fixed-position sheet: never participates in layout (zero CLS).
   z-index sits above the webchat FAB (1000) so the launcher can't cover the
   phone input; the panel-open guard keeps the popup away from an open chat. */
.sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  background: linear-gradient(180deg, #fffdf9 0%, #f7f1e8 100%);
  border-top: 1px solid rgba(210, 190, 165, 0.35);
  border-radius: 20px 20px 0 0;
  corner-shape: superellipse(1.18);
  box-shadow:
    0 -12px 40px rgba(62, 44, 28, 0.16),
    0 -2px 10px rgba(62, 44, 28, 0.07);
  overflow: hidden;
  max-height: min(92dvh, 620px);
  animation: promoSheetIn 0.38s cubic-bezier(0.22, 1, 0.36, 1) both;
}

/* bottom-sheet grab handle, floats over the photo's dark top scrim */
.sheet::before {
  content: '';
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  width: 36px;
  height: 4px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.65);
}

@keyframes promoSheetIn {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.content {
  padding: 14px 18px calc(14px + env(safe-area-inset-bottom, 0px));
}

/* Before/after: fixed-height band (≤~40% of the sheet so the input + button
   stay above the fold on mobile), frames cover-cropped to the same window. */
.mediaBox {
  position: relative;
  height: 172px;
  overflow: hidden;
  background: #d8c2a5;
}

/* top scrim for close-button legibility, bottom blend into the cream sheet */
.mediaBox::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background:
    linear-gradient(180deg, rgba(28, 22, 16, 0.28) 0%, transparent 38%),
    linear-gradient(0deg, rgba(255, 253, 249, 0.9) 0%, transparent 34%);
}

.mediaFrame {
  display: block;
  width: 100%;
  height: 172px;
  object-fit: cover;
  object-position: center 58%;
  transform: scale(1.02); /* hides crossfade edge flicker */
}

.mediaAfter {
  position: absolute;
  inset: 0;
  opacity: 0;
  animation: promoCrossfade 7s ease-in-out infinite;
  will-change: opacity;
}

/* slow push-in on the "after" frame only — sells the 3D reveal */
.mediaAfter .mediaFrame {
  animation: promoAfterZoom 7s ease-in-out infinite;
}

/* ~2.2s before → blend → ~2.5s hold on the payoff shot → blend back */
@keyframes promoCrossfade {
  0%,
  32% {
    opacity: 0;
  }
  42%,
  78% {
    opacity: 1;
  }
  90%,
  100% {
    opacity: 0;
  }
}

@keyframes promoAfterZoom {
  0%,
  32% {
    transform: scale(1.02);
  }
  42%,
  78% {
    transform: scale(1.06);
  }
  90%,
  100% {
    transform: scale(1.02);
  }
}

.mediaBadge {
  position: absolute;
  right: 12px;
  bottom: 12px;
  z-index: 2;
  padding: 4px 11px;
  border-radius: 999px;
  background: rgba(47, 38, 29, 0.74);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  color: #fffaf2;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
}

.closeButton {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 3;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  cursor: pointer;
  font-size: 22px;
  color: #2a2420;
  padding: 0;
  transition:
    transform 0.15s ease,
    background 0.15s ease;
}

.closeButton:active {
  transform: scale(0.92);
  background: rgba(255, 255, 255, 0.95);
}

.title {
  margin: 0 44px 6px 0;
  font-size: 19px;
  line-height: 1.25;
  font-weight: 600;
  letter-spacing: -0.015em;
  color: #2a2420;
}

.body {
  margin: 0 0 14px;
  font-size: 14px;
  line-height: 1.4;
  color: #6a5f54;
}

.phoneInput {
  width: 100%;
  box-sizing: border-box;
  margin: 0 0 8px;
  min-height: 48px;
  padding: 13px 16px;
  border: 1.5px solid #e0d6c8;
  border-radius: 14px;
  corner-shape: superellipse(1.1);
  background: #fffdfb;
  font-family: inherit;
  font-size: 16px; /* <16px makes iOS Safari zoom the page on focus */
  color: #2a2420;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
}

.phoneInput::placeholder {
  color: #a3988c;
}

.phoneInput:focus-visible {
  outline: none;
  border-color: #3a322c;
  box-shadow: 0 0 0 3px rgba(58, 50, 44, 0.14);
}

.consent {
  margin: 0 0 10px;
  font-size: 11px;
  line-height: 1.35;
  text-align: center;
  color: #9e948a;
}

.error {
  margin: 0 0 10px;
  font-size: 12px;
  line-height: 1.4;
  text-align: center;
  color: #c0392b;
}

.error a {
  color: inherit;
  font-weight: 600;
  text-decoration: underline;
}

.ctaRow {
  display: flex;
  justify-content: stretch;
}

.ctaRow > * {
  width: 100%;
}

/* Popup-scoped upgrade of the brand button: bigger thumb target, warm
   charcoal instead of the global neutral grey, pressed-state feedback. */
.ctaRow :global(button.ctaButton) {
  width: 100%;
  height: 52px;
  background-color: #3a322c;
  box-shadow: 0 4px 14px rgba(58, 50, 44, 0.28);
  transition:
    background-color 0.15s ease,
    transform 0.12s ease,
    opacity 0.15s ease;
}

.ctaRow :global(button.ctaButton:hover) {
  background-color: #4a4139;
}

.ctaRow :global(button.ctaButton:active:not(:disabled)) {
  transform: scale(0.98);
  background-color: #2c2622;
}

@media (min-width: 769px) {
  .sheet {
    left: 24px;
    right: auto;
    bottom: 24px;
    width: 360px;
    border-radius: 24px;
  }
}

/* short in-app viewports (SE, collapsed IG chrome): keep the form on screen */
@media (max-height: 680px) {
  .mediaBox,
  .mediaFrame {
    height: 148px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .sheet {
    animation: none;
  }
  /* Static "after" frame — the payoff shot — instead of the crossfade. */
  .mediaAfter {
    animation: none;
    opacity: 1;
  }
  .mediaAfter .mediaFrame {
    animation: none;
  }
}
